import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';

const links = [
  { name: 'Home', to: '/', hasDropdown: false },
  {
    name: 'Web Design',
    to: '/web-design',
    hasDropdown: true,
    items: [
      { label: 'All Web Design Services', to: '/web-design' },
      { label: 'Web Design for Med Spas', to: '/web-design-for-med-spas' },
      { label: 'Web Design for Tattoo Shops', to: '/web-design-for-tattoo-shops' },
      { label: 'Construction Companies', to: '/web-design-for-construction-companies' },
      { label: 'Oil Rig & Energy', to: '/web-design-for-oil-rig-companies' },
      { label: 'eCommerce Design', to: '/web-design' },
    ],
  },
  {
    name: 'A.I.',
    to: '/ai',
    hasDropdown: true,
    items: [
      { label: 'AI Integration', to: '/ai' },
      { label: 'AI Automation', to: '/ai#automation' },
      { label: 'AI Chatbots', to: '/ai#chatbots' },
    ],
  },
  {
    name: 'Marketing',
    to: '/marketing',
    hasDropdown: true,
    items: [
      { label: 'SEO Services', to: '/marketing#seo' },
      { label: 'Content Writing', to: '/marketing#content' },
      { label: 'Social Media', to: '/marketing#social' },
      { label: 'Video Advertising', to: '/marketing#video' },
    ],
  },
  {
    name: 'Hosting',
    to: '/hosting',
    hasDropdown: true,
    items: [
      { label: 'Web Hosting', to: '/hosting' },
      { label: 'Domain Names', to: '/hosting#domains' },
      { label: 'SSL Certificates', to: '/hosting#ssl' },
    ],
  },
  { name: 'Portfolio', to: '/portfolio', hasDropdown: false },
  { name: 'Blog', to: '/blog', hasDropdown: false },
];

const Logo = () => (
  <Link to="/" className="flex items-center gap-2 select-none">
    <div className="flex flex-col leading-none">
      <span className="text-[#2C5F66] text-3xl md:text-4xl tracking-tight" style={{ fontFamily: "'Pacifico', cursive" }}>
        Website
      </span>
      <span className="text-[#2C5F66] text-lg md:text-xl -mt-1" style={{ fontFamily: "'Pacifico', cursive" }}>
        Symphony
      </span>
    </div>
  </Link>
);

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeDrop, setActiveDrop] = useState(null);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((link) => {
            const isActive = location.pathname === link.to;
            return (
              <div
                key={link.name}
                className="relative"
                onMouseEnter={() => link.hasDropdown && setActiveDrop(link.name)}
                onMouseLeave={() => setActiveDrop(null)}
              >
                <NavLink
                  to={link.to}
                  className={`px-4 py-2 font-medium text-[15px] flex items-center gap-1 transition-colors ${
                    isActive ? 'text-[#D9A04A]' : 'text-[#2C5F66] hover:text-[#D9A04A]'
                  }`}
                >
                  {link.name}
                  {link.hasDropdown && <ChevronDown size={14} className="text-[#D9A04A]" />}
                </NavLink>
                {link.hasDropdown && activeDrop === link.name && (
                  <div className="absolute top-full left-0 bg-white shadow-xl border border-gray-100 rounded-md py-2 min-w-[220px] z-50">
                    {link.items.map((item) => (
                      <Link
                        key={item.label}
                        to={item.to}
                        className="block px-5 py-2 text-sm text-gray-700 hover:bg-[#f5f5f5] hover:text-[#D9A04A] transition-colors"
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          <Link
            to="/contact"
            className="ml-3 bg-[#C68B30] hover:bg-[#B17A24] text-white font-semibold px-7 py-3 rounded-md transition-colors"
          >
            Free Quote
          </Link>
        </nav>

        <button
          className="lg:hidden text-[#2C5F66]"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="toggle menu"
        >
          {mobileOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-gray-100 bg-white">
          <div className="px-6 py-4 flex flex-col gap-2">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className="py-2 text-[#2C5F66] font-medium border-b border-gray-100"
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileOpen(false)}
              className="mt-3 bg-[#C68B30] hover:bg-[#B17A24] text-white font-semibold px-6 py-3 rounded-md text-center transition-colors"
            >
              Free Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
